module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('div', {
    staticClass: "p-t-sm",
    staticStyle: {
      "padding-bottom": "30px"
    },
    attrs: {
      "id": "home-top-area"
    }
  }, [void 0], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "inner-content",
    attrs: {
      "id": "home-info-area"
    }
  }, [_c('button', {
    staticClass: "pull-right c-b c-b-all m-t",
    on: {
      "click": function($event) {
        return _vm.seeNewsList()
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('h3', {
    staticClass: "content-h"
  }, [_vm._v("婚礼资讯")]), _vm._v(" "), _c('div', {
    staticClass: "content-d"
  }, [_vm._v("Wedding information")]), _vm._v("\n      " + _vm._s( /** actuall content here */ ) + "\n      "), _c('div', {
    staticClass: "line2 m-t-30"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix m-t-30"
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      staticClass: "m-t-30",
      on: {
        "click": function($event) {
          return _vm.goPosterDetail(item.uuid)
        }
      }
    }, [_vm._v("\n          " + _vm._s( /** use background for image */ ) + "\n        "), _c('div', {
      staticClass: "clearfix news-info"
    }, [_c('div', {
      staticClass: "f-5 pull-right m-t-89"
    }, [_vm._v("浏览：" + _vm._s(item.viewNumber) + "次")]), _vm._v(" "), _c('div', {
      staticClass: "f-1 m-t-11 c-p"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "f-2 m-t-3"
    }, [_vm._v(_vm._s(item.createTime.substring(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "rectangle-theme f-3  m-t-12"
    }, [_vm._v(_vm._s(item.themeTitle))]), _vm._v(" "), (item.type !== 4 && item.content[0] != null) ? _c('div', [_c('div', {
      staticClass: "line2 m-t-20"
    }), _vm._v(" "), _c('div', {
      staticClass: "rectangle-textarea f-4 clamp m-t-20"
    }, [_vm._v(_vm._s(item.content[0].text))])]) : _vm._e(), _vm._v(" "), (item.type === 4) ? _c('div', [_c('div', {
      staticClass: "line2 m-t-20"
    }), _vm._v(" "), _c('div', {
      staticClass: "rectangle-textarea f-4 clamp m-t-20"
    }, [_vm._v(_vm._s(item.content.text))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "img-n-div img-c-div",
      style: ({
        backgroundImage: 'url(' + item.cover + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "line2 m-t-30"
    })])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a3d9cde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 606
// module chunks = 1